export const battleZh = {
  battle: {
    viewBattle: '查看',
    battleCenter: '极速抢答',
    tips1: '你还没有加入任何对战'
  }
}
export const battleEn = {
  battle: {
    viewBattle: 'Enter',
    battleCenter: 'Battle Center',
    tips1: 'You haven\'t joined any battles'
  }
}



// WEBPACK FOOTER //
// ./src/i18n/langs/battle/index.js